import styled from "styled-components";

export const FileCardContainer = styled.div.attrs({})`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  cursor: pointer;
  width: min(100%, 780px);
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  border-radius: 24px;
  overflow: hidden;

`;
export const FileCardContent = styled.div.attrs({})`
  display: flex;
  position: relative;
  width: 100%;
  min-height: 360px;
  max-height: 520px;
  aspect-ratio: 16 / 9;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  background: ${p => p.theme.palette.colors.backgroundStrong};

  @media(max-width: 767px){
    min-height: 260px;
    aspect-ratio: 4 / 3;
  }

`;
export const FileCardButton = styled.div.attrs({})`
  display: flex;
  height: 56px;
  padding: 7px 32px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 32px;
  font-family: Lato;
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  text-transform: uppercase;
  color: ${p => p.theme.palette.blue.main};
  background: ${p => p.theme.palette.colors.white};
`;

export const FileCardTitle = styled.div.attrs({})`
  font-family: Lato;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  color: ${p => p.theme.palette.colors.text};
  line-height: 1.35;
  padding: 0;
  width: 100%;
  text-align: left;
  text-shadow: 0 1px 10px ${p => p.theme.palette.colors.shadowStrong};
`;

export const DocumentImg = styled.img.attrs({})`
  object-fit: contain;
  width: 100%;
  height: 100%;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
`;

export const FilePreviewImage = styled.img.attrs({})`
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: ${p => p.theme.palette.colors.white};
`;

export const PdfPreviewFrame = styled.iframe.attrs({})`
  width: 100%;
  height: 100%;
  border: 0;
  background: ${p => p.theme.palette.colors.white};
`;

export const FileCardFooter = styled.div.attrs({})`
  width: 100%;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 16px;
  align-items: center;
  padding: 18px 24px;
  background: ${p => p.theme.palette.colors.backgroundStrong};

  @media(max-width: 767px){
    grid-template-columns: 1fr;
  }
`;

export const FileCardDownloadButton = styled.button.attrs({})`
  appearance: none;
  border: 1px solid ${p => p.theme.palette.blue.main};
  border-radius: 10px;
  padding: 10px 16px;
  font-family: Lato;
  font-size: 14px;
  font-weight: 700;
  color: ${p => p.theme.palette.colors.white};
  background: ${p => p.theme.palette.blue.main};
  cursor: pointer;
`;

export const FilePreviewFallback = styled.div.attrs({})`
  width: 100%;
  height: 100%;
  min-height: inherit;
  display: flex;
  flex-direction: column;
  gap: 14px;
  align-items: center;
  justify-content: center;
  background: ${p => p.theme.palette.blue.main};
`;

export const FilePreviewFallbackText = styled.div.attrs({})`
  font-family: Lato;
  font-size: 15px;
  font-weight: 700;
  color: ${p => p.theme.palette.colors.white};
`;
